import script from "./AddProjectPlaybackChannelModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddProjectPlaybackChannelModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddProjectPlaybackChannelModal.vue?vue&type=style&index=0&id=74e63df4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e63df4"]])

export default __exports__